/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { ProjectBasicSettingAttributeInfo } from './ProjectBasicSettingAttributeInfo';

export type ProjectBasicSettingInfo = {
    ID: string;
    TNM: string;
    TSB: string;
    TDESC: string;
    TTHUNMB: string;
    ATTRIB: Array<ProjectBasicSettingAttributeInfo>;
    TPMT: ProjectBasicSettingInfo.TPMT;
    PRIKEY?: string;
    FAV?: string;
};

export namespace ProjectBasicSettingInfo {

    export enum TPMT {
        CMC = 'CMC',
        COIN_GECKO = 'COIN_GECKO',
        XANGLE = 'XANGLE',
    }


}

